import { Avatar } from "../ui/avatar";
import { WelcomeSection } from "./WelcomeSection";
export const HomeHeader = () => {
  return (
    <div className="flex items-center justify-between w-full h-14">
      <WelcomeSection />
      
      <Avatar className="w-14 h-14">
        <img
          className="object-cover w-full h-full rounded-full"
          alt="Two And Five Logo"
          src="/two-and-five-blue-white.svg"
          width={56}
          height={56}
        />
      </Avatar>
    </div>
  );
};